import { render, staticRenderFns } from "./TrafficData.vue?vue&type=template&id=7bd1d046&scoped=true"
import script from "./TrafficData.vue?vue&type=script&lang=js"
export * from "./TrafficData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd1d046",
  null
  
)

export default component.exports